<template>
    <div class="home-region knowledge">
        <div class="region-cont">
            <div class="tit tit-blue">知识应用 <div class="tit-bottom"></div></div>
            <ul class="knowledge-list">
                <li class="list" v-for="(item,index) in knowledgeList" :key="index">
                    <a>
                        <div class="icon">
                            <img width="100%" :src="item.img" alt="">
                        </div>
                        <p class="list-tit">{{item.tit}}</p>
                        <p class="list-txt">{{item.txt}}</p>
                        <div class="list-btn" @click="toPage(item)">
                            点击查看<span class="look-icon"></span>
                        </div>
                    </a>
                </li> 
            </ul>
        </div>
    </div>
</template>

<script>
import homeData from '../homeData.js'; 
export default {
    data () {
        return {
            knowledgeList:homeData.knowledgeList,
        }
    },
    methods: {
        toPage(item){  
            // if(item.isLoad&&!isLoad()){ 
            //     this.$message.error( '请先登录～')
            //     return 
            // } 
            if(item.path&&item.path!=''){ 
               let url= this.$router.resolve({
                    path:item.path,
                    query:{
                        changeflag:2
                    }
                }) 
                this.$windowOpen({ url:url.href,isLogin:true} ) 
            }
        }
    }
}
</script>

<style lang="less" scoped>
// 知识应用
.knowledge{ 
    .knowledge-list{
        // margin-right: -22px;
        display: flex;
        justify-content: space-between;
        .list{
            width: 222px;
            height: 324px;
            margin-right: 22px;
            padding-top:76px; 
            a{ 
                border-radius: 8px; 
                background: #F1F5FE; 
                padding-top:70px;
                color: #333;
                text-align: center;
                &:hover{
                    color: #fff;
                    background: linear-gradient(180deg,#A0CFFF 0%,#165DFF 100%);
                    .list-btn{
                        
                        border: 1px solid #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #fff;
                        .look-icon{
                            margin-left: 4px;
                            display: block;
                            width: 14px;
                            height: 6px;
                            background: url('../../../assets/images/home/look-icon.png') no-repeat;
                            background-size: contain;
                        }
                    }
                }
                .icon{
                    width: 202px;
                    height: 178px;
                    position: absolute;
                    top:-82px;
                    left: 30px;
                }
                .list-tit{
                    font-size: 18px;
                    line-height: 18px;
                    font-weight: bold;
                    margin: 16px 0;
                }
                .list-txt{
                    font-size: 12px;
                    line-height: 12px;
                    margin-bottom: 48px;
                }
                .list-btn{
                    width: 124px;
                    height: 32px;
                    line-height: 30px;
                    color: #386DE8;
                    border: 1px solid #386DE8;
                    border-radius: 16px;
                    margin: 0 auto;
                    cursor: pointer;
                    
                }
            }
        }
    }
}
</style>